import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

import { Input } from '../../lib/form/fields';
import { requiredField, emailField } from '../../lib/form/validators';

const ForgotPasswordForm = ({ valid, handleSubmit, onSubmit, loading }, context) => {
  return (
    <form onSubmit={handleSubmit(values => onSubmit(values))}>
      <Field
        name="email"
        type="email"
        label={context.t('FORGOT-PASSWORD-FORM.EMAIL.LABEL')}
        placeholder={context.t('FORGOT-PASSWORD-FORM.EMAIL.PLACEHOLDER')}
        component={Input}
      />

      <button className="btn btn-lg btn-block btn-primary mb-3" disabled={!valid}>
        {context.t('FORGOT-PASSWORD-FORM.BUTTON.SUBMIT')}
        {loading && (
          <div className="spinner-border spinner-border-sm ml-2" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        )}
      </button>
    </form>
  );
};

ForgotPasswordForm.contextTypes = {
  t: PropTypes.func.isRequired,
};

const forgotPasswordFormValidator = formProps => {
  const errors = {};
  requiredField(formProps, errors, 'email', 'FORGOT-PASSWORD-FORM.EMAIL.ERROR_REQUIRED');
  emailField(formProps, errors, 'email', 'FORGOT-PASSWORD-FORM.EMAIL.WRONG_FORMAT');
  return errors;
};

export default reduxForm({
  form: 'ForgotPasswordForm',
  validate: forgotPasswordFormValidator,
})(ForgotPasswordForm);
